'use strict'

define ['./welcomeModal.css'], () ->
  ($scope, $rootScope, $uibModalInstance, $cacheFactory, RentappService, $window) ->
    $scope.user_type = null;

    RentappService.getMe()
      .then (user) ->
        $scope.user_type = user.landlord.user_type





// WEBPACK FOOTER //
// ./components/dashboard/forms/welcomeModal.coffee